import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ProceduresRoutingModule} from './procedures-routing.module';
import {ProceduresComponent} from './procedures.component';
import {CreateEditProcedureComponent} from './create-edit-procedure/create-edit-procedure.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {NgSelect2Module} from 'ng-select2';
import {ViewProcedureComponent} from './view-procedure/view-procedure.component';
import {ListProceduresComponent} from './list-procedures/list-procedures.component';
import {InlineSVGModule} from 'ng-inline-svg';
import {DataTablesModule} from 'angular-datatables';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {SharedModule} from '../../shared/shared.module';
import {NgbAlertModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {GeneralButtonComponent} from '../../_upsell/shared/components/general-button/general-button.component';


@NgModule({
    declarations: [
        ProceduresComponent,
        CreateEditProcedureComponent,
        ViewProcedureComponent,
        ListProceduresComponent,
        GeneralButtonComponent
    ],
    exports: [
        GeneralButtonComponent
    ],
    imports: [
        CommonModule,
        ProceduresRoutingModule,
        ReactiveFormsModule,
        TranslateModule,
        NgSelect2Module,
        InlineSVGModule,
        DataTablesModule,
        FormsModule,
        MatCheckboxModule,
        SharedModule,
        NgbAlertModule,
        NgbTooltipModule,
        AngularEditorModule
    ]
})
export class ProceduresModule {
}
